import { useGetLanguageQueryParam } from '@/helpers/languageHooks'
import {Language} from '@/enums/language'

export const DualLanguageStr = ({ english, spanish }) => {
  const val = useGetLanguageQueryParam()

  return val === Language.SPANISH_ABBR ? <>{spanish}</> : <>{english}</>
}
